// Бренд-марка публичных auth-страниц: та же amber-плитка с «G», что в сайдбаре,
// в Warm Precision дисциплине (32×32, радиус M10, без теней). Тёмная тема
// следует токену --ant-color-primary.
import type { ReactElement } from 'react';

export function AuthMark(): ReactElement {
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        width: 32,
        height: 32,
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        borderRadius: 10,
        backgroundColor: 'var(--ant-color-primary)',
        color: '#ffffff',
        fontSize: 13,
        fontWeight: 700,
      }}
    >
      G
    </span>
  );
}
